import React from "react";
import dranoop from "../../assets/images/dr_anoop.jpg";
function About() {
  return (
    <section id="about" class="py-20 bg-white">
      <div class="container mx-auto px-4">
        <div class="grid md:grid-cols-2 gap-12 items-center">
          <div class="relative animate__animated animate__fadeInLeft">
            <div class="absolute inset-0 bg-emerald-500 rounded-full opacity-10 blur-3xl"></div>
            <img
              src={dranoop}
              alt="Dr Anoop Choudhary Profile"
              class="relative rounded-3xl shadow-xl w-full max-w-md mx-auto"
            />
          </div>

          <div class="space-y-6 animate__animated animate__fadeInRight">
            <h2 class="text-3xl md:text-4xl font-bold text-neutral-900 font-poppins">
              About Dr Anoop Choudhary
            </h2>

            <div class="space-y-4 text-neutral-700 font-poppins">
              <p>
                Dr. Anoop Choudhary is a distinguished homeopathy practitioner
                based in Bhopal, known for his expertise in holistic healthcare.
                He holds a BHMS degree from Hahnemann Homeopathic Medical
                College and an MD in Pediatrics from Maharashtra University of
                Health Sciences.
              </p>
              <p>
                With over 20 years of experience, Dr. Choudhary has successfully
                treated thousands of patients, addressing a wide range of health
                issues from chronic conditions to acute ailments.
              </p>
              <p>
                Dr. Choudhary's practice, Homeo Hopes, is located in the heart
                of Malviya Nagar, Bhopal, making it easily accessible for
                patients seeking reliable homeopathic care. His clinic is
                renowned for its personalized treatment plans, where each
                patient receives tailored care based on their unique medical
                history and health concerns.
              </p>
            </div>

            <div class="grid grid-cols-2 gap-6 pt-6">
              <div class="bg-neutral-50 p-6 rounded-xl">
                <h3 class="text-2xl font-bold text-emerald-600 font-poppins">
                  20+
                </h3>
                <p class="text-neutral-600 font-poppins">Years Experience</p>
              </div>
              <div class="bg-neutral-50 p-6 rounded-xl">
                <h3 class="text-2xl font-bold text-emerald-600 font-poppins">
                  10k+
                </h3>
                <p class="text-neutral-600 font-poppins">Patients Treated</p>
              </div>
            </div>

            <div class="pt-6">
              <a
                href="#appointment"
                class="inline-block font-poppins bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full transition-colors"
              >
                Book an Appointment
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
